export default __webpack_public_path__ + "static/media/dog-thumbnail.jpg.b7214be6.txt";